import { useAuth, PROFILO } from "@/contexts/AuthContext";

/**
 * Il ruolo dell'utente, con gli stati in cui NON lo si conosce.
 *
 * In questo gestionale il ruolo decide cosa vedi e fin dove puoi scendere di
 * prezzo. Dichiararne uno che il programma non conosce è un dato inventato a
 * schermo: il giorno in cui `/me` tarda un secondo, Aleandro si vedrebbe
 * «Venditore». Quindi qui il ruolo non si indovina mai: o è quello vero, o si
 * dice che manca.
 *
 * I quattro stati:
 *   assente → nessuna sessione: non c'è un utente, quindi non c'è un ruolo.
 *   attesa  → c'è la sessione, il profilo sta arrivando. Si mostra uno scheletro.
 *   ignoto  → il profilo non è arrivato, oppure è arrivato con un `ruolo` che
 *             non è fra i quattro. Si scrive che manca.
 *   noto    → il ruolo è uno dei quattro. Solo qui si stampa un'etichetta.
 *
 * La differenza fra «sta arrivando» e «non arriva» la dichiara `AuthContext`
 * con `profiloStato`, che è l'unico posto che la sa davvero. Prima non c'era e
 * qui viveva un timer da 2,5 s che tirava a indovinare il confine fra i due:
 * ora `ignoto` compare nell'istante esatto in cui la chiamata fallisce.
 */
export const RUOLI = {
  titolare: { stato: "info", label: "Titolare" },
  amministrazione: { stato: "neutro", label: "Amministrazione" },
  venditore: { stato: "ok", label: "Venditore" },
  montatore: { stato: "attenzione", label: "Montatore" },
};

export function useRuoloUtente() {
  const { session, profile, profiloStato, loading } = useAuth() || {};
  const ruolo = profile?.ruolo ? RUOLI[profile.ruolo] || null : null;

  if (loading) return { stato: "attesa", ruolo: null };
  if (!session) return { stato: "assente", ruolo: null };
  if (ruolo) return { stato: "noto", ruolo };
  /* `profiloStato` assente vuol dire provider vecchio o finto: in quel caso non
     sappiamo se stia arrivando, e fra le due risposte sbagliate si sceglie
     quella che non inventa un ruolo. */
  if (profiloStato === PROFILO.IN_CORSO) return { stato: "attesa", ruolo: null };
  return { stato: "ignoto", ruolo: null };
}

export default useRuoloUtente;
